import { render, staticRenderFns } from "./Values.vue?vue&type=template&id=2e23b99a&"
import script from "./Values.vue?vue&type=script&lang=js&"
export * from "./Values.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports